/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown> }} Drastic_Tech_Importing_File_LogInputs */

const en_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing ${i?.format} file...`)
};

const fr_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importation du fichier ${i?.format}...`)
};

const de_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importiere die Datei ${i?.format}...`)
};

const it_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione del file ${i?.format}...`)
};

const ru_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт файла ${i?.format}...`)
};

const es_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando archivo ${i?.format}...`)
};

const zh_cn2_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在导入${i?.format}文件...`)
};

const ja_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} ファイルをインポートしています...`)
};

const hi_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल आयात की जा रही है...`)
};

const pt_pt2_drastic_tech_importing_file_log = /** @type {(inputs: Drastic_Tech_Importing_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando o arquivo ${i?.format}...`)
};

/**
* | output |
* | --- |
* | "Importing {format} file..." |
*
* @param {Drastic_Tech_Importing_File_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_importing_file_log = /** @type {((inputs: Drastic_Tech_Importing_File_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Importing_File_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_importing_file_log(inputs)
	if (locale === "de") return de_drastic_tech_importing_file_log(inputs)
	if (locale === "it") return it_drastic_tech_importing_file_log(inputs)
	if (locale === "ru") return ru_drastic_tech_importing_file_log(inputs)
	if (locale === "es") return es_drastic_tech_importing_file_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_importing_file_log(inputs)
	if (locale === "ja") return ja_drastic_tech_importing_file_log(inputs)
	if (locale === "hi") return hi_drastic_tech_importing_file_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_importing_file_log(inputs)
	return en_drastic_tech_importing_file_log(inputs)
});